import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import moment from "moment";

import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

import { useStyles } from "./AuthorBooks.css";

class AuthorBooks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: "",
      toShowLength: 15,
      showMore: true,
    };
  }

  handleChange = (panel) => {
    this.state.expanded === panel
      ? this.setState({ expanded: false, showMore: true })
      : this.setState({ expanded: panel, showMore: true });
  };

  handleEdit = (bookId) => {
    this.props.history.push(`author/book/edit/${bookId}`);
  };

  setShowLength = (length) => {
    this.setState({
      toShowLength: length,
      showMore: false,
    });
  };

  compare = (a, b) => {
    const nameA = a.publishedDate;
    const nameB = b.publishedDate;

    let comparison = 0;
    if (nameA < nameB) {
      comparison = 1;
    } else if (nameA > nameB) {
      comparison = -1;
    }
    return comparison;
  };

  render() {
    const { classes, books, currentPage, postPerPage } = this.props;
    this.props.books.sort(this.compare);
    return (
      <Grid container spacing={3}>
        {books
          .slice(
            (currentPage - 1) * postPerPage,
            (currentPage - 1) * postPerPage + postPerPage
          )
          .map((book, index) => (
            <Grid item xs={12} sm={12} md={6} xl={6} lg={6} key={index}>
              <Paper className={classes.paper}>
                <div
                  style={{
                    padding: 5,
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <b
                    style={{
                      fontSize: 24,
                      flexGrow: 1,
                    }}
                  >
                    {book.title}
                  </b>
                  <div>
                    {book.bookVerified ? null : (
                      <Tooltip
                        arrow
                        title="Edit"
                        className={classes.tooltip}
                        onClick={() => this.handleEdit(book._id)}
                      >
                        <EditIcon />
                      </Tooltip>
                    )}
                    <Tooltip arrow title="Delete" className={classes.tooltip}>
                      <DeleteIcon />
                    </Tooltip>
                  </div>
                </div>
                <div className={classes.contentRoot}>
                  <img
                    src={book.bookCoverUrl}
                    alt="bookCover"
                    style={{ width: 200, height: 200 }}
                  />
                  <div className={classes.detailStyle}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <b style={{ flexGrow: 1 }}>Published Date:</b>
                      <div>
                        {moment(new Date(book.publishedDate)).format("LL")}
                      </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <b style={{ flexGrow: 1 }}>Price:</b>
                      <div>{book.price}</div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <b style={{ flexGrow: 1 }}>Total Page: </b>
                      <div>{book.pageCount}</div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <b style={{ flexGrow: 1 }}>Genre:</b>
                      <div>{book.genre}</div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <b style={{ flexGrow: 1 }}>Book file:</b>
                      <div>
                        {book.bookFileUrl ? (
                          <CheckIcon style={{ color: "green" }} />
                        ) : (
                          <ClearIcon style={{ color: "red" }} />
                        )}
                      </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <b style={{ flexGrow: 1 }}>Book Verified:</b>
                      <div>
                        {book.bookVerified ? (
                          <CheckIcon style={{ color: "green" }} />
                        ) : (
                          <ClearIcon style={{ color: "red" }} />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Paper>
            </Grid>
          ))}
      </Grid>
    );
  }
}

export default withStyles(useStyles)(withRouter(AuthorBooks));
